import { useEffect } from 'react'
import { useUserStore } from '@/entities/user'
import { queryClient } from '@/shared/api'
import { subscribeToAuthEvents } from '@/shared/lib/auth-sync'
import { useAuth } from './use-auth'

export function AuthBootstrap() {
  const { refresh } = useAuth()
  const clearUser = useUserStore((state) => state.clearUser)

  useEffect(() => {
    void refresh()
  }, [refresh])

  useEffect(() => {
    return subscribeToAuthEvents((event) => {
      if (event === 'logout') {
        queryClient.clear()
        clearUser()
      }
    })
  }, [clearUser])

  return null
}
